import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import iconChat from "../../assets/icon-chat.png";
import logoMedical from "../../assets/logo-medical.png";
import NextButton from "../../components/NextButton";
import { ROUTES } from "../../utils/constants";
import { SERVER_URL } from "../../api";
import { useGameTexts } from "../../hooks/useGameTexts";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario1ConversationIntro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const prevState = useLocation();
	const group = useSelector((state) => state?.group);
	const { texts, ready } = useGameTexts(group?.game);

	const title = texts["scenario1.conversationIntro.title"] ?? "";
	const content = texts["scenario1.conversationIntro.content"] ?? "";
	const introImageUrl = (texts["avatar.intro.consultation"] && buildImageUrl(texts["avatar.intro.consultation"])) || null;

	if (group?.game && !ready) {
		return (
			<div className="h-100 d-flex align-items-center justify-content-center">
				<div className="txtWhite">Cargando...</div>
			</div>
		);
	}

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} alt="" />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5 pt-5">
					<div className="col-10">
						<div className="ms-5 ps-4 d-flex align-items-center">
						<div className="col-3 d-flex justify-content-center mt-5">
						<div className="patient-avatar-circle" style={{ width: 300, height: 300 }}>
							{introImageUrl ? (
								<img src={introImageUrl} alt="" style={{ width: 300, height: 300, objectFit: "cover" }} />
							) : (
								<div style={{ width: 300, height: 300, background: "#e0e8ec", borderRadius: "50%" }} aria-hidden />
							)}
						</div>
					</div>
							<div className="ms-4 txtWhite txt20 text-center">
								<img width={48} src={iconChat} alt="" />
								<div className="bold my-3">
									{title && title.indexOf("<") >= 0 ? (
										<span dangerouslySetInnerHTML={{ __html: title }} />
									) : (
										title
									)}
								</div>
								<div>
									{content && content.indexOf("<") >= 0 ? (
										<span dangerouslySetInnerHTML={{ __html: content }} />
									) : (
										content
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton navigateTo={ROUTES.SCENARIO1_CONVERSATION} />
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario1ConversationIntro);
